import { IAccQuyDoiTyGia } from "./../../../model/respone/category/IAccQuyDoiTyGia";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAccQuyDoiTyGiaActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IAccQuyDoiTyGia[],
  LOAD_ERRR: "",

  SAVE_START: {} as IAccQuyDoiTyGia,
  SAVE_SUCCESS: {} as IAccQuyDoiTyGia,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IAccQuyDoiTyGia,
  CLOSE_EDIT_MODAL: undefined,
};
export const eAccQuyDoiTyGiaActionIds = generateActionTypeIds(
  eAccQuyDoiTyGiaActionsObj,
  "QUY_DOI_TY_GIA",
);
export type IAccQuyDoiTyGiaActionTypes = IGenericActionType<
  typeof eAccQuyDoiTyGiaActionsObj,
  "QUY_DOI_TY_GIA"
>;
